export const NAV_ITEMS = [
  {
    id: "dashboard",
    iconSrc: "/images/navIcon-dashboard.svg",
    label: "Dashboard",
    url: "Vendor",
  },
  {
    id: "myproducts",
    iconSrc: "/images/navIcon-my-products.svg",
    label: "My Products",
    url: "Vendor/myproducts",
  },
  // {
  //   id: "ticketManagement",
  //   iconSrc: "/images/ticket-mgmt.svg",
  //   label: "Ticket Management",
  //   url: 'Vendor/ticketManagement"
  // },
  // {
  //   id: "actionRequestHistory",
  //   iconSrc: "/images/action-request-history.svg",
  //   label: "Action Request History",
  //   url: 'Vendor/actionRequestHistory'
  // },
];
export const SUB_NAV_ITEMS = [
  {
    id: "help",
    iconSrc: "/images/question_mark.svg",
    label: "Help",
    url: "Vendor/help",
  },
];
